import React from 'react';
import { Shield, Download, Lock, Infinity as InfinityIcon, Star } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-4 pb-16 px-4 relative overflow-hidden" data-id="element-59">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-lightBlue/10 rounded-full blur-[120px] pointer-events-none" data-id="element-60"></div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-61">
        <h1 className="font-heading text-4xl md:text-6xl font-bold mb-6 tracking-tight uppercase leading-none" data-id="element-62">
          SALUD Y ADOLESCENCIA 360: <br data-id="element-63" />
          <span className="text-brand-accent italic" data-id="element-64">
            Herramientas Completas
          </span>
        </h1>

        {/* Product Image */}
        <div className="mb-8 flex justify-center" data-id="element-65">
          <a href="#compra" className="block cursor-pointer transition-transform hover:scale-105 duration-300" data-id="element-66">
            <img src="https://cdn.magicpatterns.com/uploads/koRjTCYB5GieHYEs69LebH/MOCKUP_SYA.png" alt="Salud y Adolescencia 360" className="w-full max-w-lg mx-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-67" />
          </a>
        </div>

        <h2 className="font-heading text-xl md:text-2xl font-bold mb-3 text-gray-300 max-w-3xl mx-auto uppercase" data-id="element-68">
          El sistema más completo de clases, proyectos y evaluaciones listos
          para usar.
        </h2>

        <h3 className="text-lg md:text-xl mb-8 text-gray-400 font-body font-medium max-w-2xl mx-auto" data-id="element-69">
          Todo el año de Salud y Adolescencia resuelto. Sin planificar nada
          desde cero.
        </h3>

        <div className="mb-6" data-id="element-70">
          <CTAButton text="👉 Quiero acceso inmediato" className="w-full md:w-auto" data-id="element-71" />
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm md:text-base font-medium text-gray-400 font-body mb-6" data-id="element-72">
          <div className="flex items-center gap-2" data-id="element-73">
            <Lock className="w-5 h-5 text-brand-accent" data-id="element-74" />
            <span data-id="element-75">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-76">
            <Download className="w-5 h-5 text-brand-accent" data-id="element-77" />
            <span data-id="element-78">Descarga inmediata</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-79">
            <Shield className="w-5 h-5 text-brand-accent" data-id="element-80" />
            <span data-id="element-81">Garantía 7 días</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-82">
            <InfinityIcon className="w-5 h-5 text-brand-accent" data-id="element-83" />
            <span data-id="element-84">Acceso de por vida</span>
          </div>
        </div>

        {/* Badge - moved below trust badges */}
        <div className="inline-flex items-center gap-2 border border-brand-accent/30 bg-brand-accent/10 text-brand-accent px-4 py-1.5 rounded-full text-xs md:text-sm font-bold tracking-wide" data-id="element-85">
          <Star className="w-4 h-4 fill-brand-accent" data-id="element-86" />
          EL SISTEMA #1 PARA DOCENTES DE SALUD
          <Star className="w-4 h-4 fill-brand-accent" data-id="element-87" />
        </div>
      </div>
    </section>;
}